import { Controller } from "@hotwired/stimulus";

// Server text is UTC; Intl on <html lang> renders the viewer's local time without host packages.
export default class extends Controller {
  static targets = ["date", "time"];
  static values = { iso: String };

  connect() {
    if (!this.hasIsoValue || !this.isoValue) return;

    const language =
      (typeof document !== "undefined" && document.documentElement.lang) ||
      (typeof navigator !== "undefined" && navigator.language) ||
      "en-GB";

    try {
      const date = new Date(this.isoValue);
      if (Number.isNaN(date.getTime())) return;
      const dateText = new Intl.DateTimeFormat(language, {
        day: "numeric",
        month: "short",
        year: "numeric",
      }).format(date);
      const timeText = new Intl.DateTimeFormat(language, {
        hour: "2-digit",
        minute: "2-digit",
      }).format(date);

      if (this.hasDateTarget || this.hasTimeTarget) {
        if (this.hasDateTarget) this.dateTarget.textContent = dateText;
        if (this.hasTimeTarget) this.timeTarget.textContent = timeText;
      } else {
        this.element.textContent = `${dateText} ${timeText}`;
      }
    } catch (error) {
      console.warn("ui--format-datetime: could not format", error);
    }
  }
}
